<template>
   <div>
      <b-modal
         :id="id"
         :title="addManageLabel"
         centered
         size="xl"
         @hidden="hidden"
         no-close-on-backdrop
         no-close-on-esc
         hide-footer
      >
         <div class="cr-modal-content">
            <SuppliesDeclarations v-if="expenseType === 'supplies'" />
            <CloudDeclarations v-if="expenseType === 'cloud'" />
            <ContractorsDeclarations v-if="expenseType === 'contractors'" />
            <p class="utilization-info-text mb-3">
               {{ skipSectionLabel }}
            </p>
            <div class="d-flex justify-content-end mt-3 action-button">
               <b-button
                  :disabled="!hasDeclarationByEntityType"
                  variant="primary"
                  class="action-button light-button"
                  style="width: 7.5rem"
                  @click="onNextClick"
                  >Next</b-button
               >
            </div>
         </div>
      </b-modal>
   </div>
</template>

<script>
import SuppliesDeclarations from './SuppliesDeclarations.vue';
import CloudDeclarations from './CloudDeclarations.vue';
import ContractorsDeclarations from './ContractorsDeclarations.vue';
import {EXPENSE_ENTITY_LABEL_CONFIG} from '@/helpers/baseConfig';
import {expensePermissionsMixin} from '@/mixins';

export default {
   name: 'UtilizationSuppliesModal',
   components: {ContractorsDeclarations, CloudDeclarations, SuppliesDeclarations},
   mixins: [expensePermissionsMixin],

   props: {
      /**
       * TODO: Add `employees` support here when employee declarations are implemented
       * for the expenses utilization modal flow.
       */
      expenseType: {
         type: String,
         required: true,
         validator: (value) => ['cloud', 'supplies', 'contractors'].includes(value),
      },
   },

   data() {
      return {hasUploadedFiles: false, stateSelection: null};
   },

   computed: {
      declaration() {
         return this.$store.getters[`${this.expenseType}/declaration`];
      },

      id() {
         return `modal-utilization-${this.expenseType}`;
      },

      hasInSingleUSStates() {
         return this.declaration === 'ONE';
      },

      hasInManyUSStates() {
         return this.declaration === 'MANY';
      },

      hasDeclarationByEntityType() {
         if (this.expenseType === 'supplies') {
            return this.hasInSingleUSStates || this.hasInManyUSStates;
         } else {
            return this.declaration;
         }
      },

      entityLabelPlural() {
         return (
            EXPENSE_ENTITY_LABEL_CONFIG[this.expenseType]?.plural ||
            EXPENSE_ENTITY_LABEL_CONFIG.supplies.plural
         );
      },

      entityLabelPluralLower() {
         return (
            EXPENSE_ENTITY_LABEL_CONFIG[this.expenseType]?.pluralLower ||
            EXPENSE_ENTITY_LABEL_CONFIG.supplies.pluralLower
         );
      },

      skipSectionLabel() {
         return `If you did not use ${this.entityLabelPluralLower}, we can skip this section.`;
      },
   },

   methods: {
      show() {
         this.$bvModal.show(this.id);
      },

      onEdit() {
         this.$emit('editSupplies');
      },

      hide() {
         this.$bvModal.hide(this.id);
      },

      hidden() {
         this.$emit('afterClose');
      },

      onNextClick() {
         this.$emit('onNextClick');
      },
   },
};
</script>

<style scoped lang="scss">
.cr-modal-content {
   padding: 0.5rem 0 0 0;
   color: #212529;

   section {
      height: 500px;
   }
}
.utilization-info-text {
   font-size: 0.8125rem;
}
.action-button {
   font-size: 0.75rem;
}

.modal-subtitle {
   font-size: 1.25rem;
   font-weight: bold;
}

.modal-footer > * {
   margin: 0 !important;
}
</style>
